export enum BetaBadgeSize {
  Default = 'badge-beta',
  Sm = 'badge-beta-sm'
}
